export const guest_route = 'login';
export const auth_route = 'dashboard';
export const logout_route = 'logout';